module.exports = __webpack_public_path__ + "img/icon-add-bule.49bae0af.svg";